export class EksRestoreTargetClusters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusterNames",
            "baseName": "clusterNames",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return EksRestoreTargetClusters.attributeTypeMap;
    }
    constructor() {
    }
}
